import React from "react";
import {
  useDateRange,
  useDateRangeIsClipped,
  useRetentionHorizon,
  useSetDateRange,
} from "providers/WithDateRange";
import DateRangeSelector from "ui/DateRangeSelector";

import { formatTimestampShorter } from "utils/format";
import pluralize from "pluralize";
import moment, { Moment } from "moment-timezone";

import styles from "./style.module.scss";

function DateRangeBar({ feature }: { feature?: string }) {
  const { from, to, label } = useDateRange();
  const setRange = useSetDateRange();
  const earliest = useRetentionHorizon();
  const adjustedEarliest = moment.min(earliest, from);

  return (
    <div className={styles.container}>
      <RetentionNotice feature={feature} />
      <DateRangeSelector
        from={from}
        to={to}
        label={label}
        earliest={adjustedEarliest}
        onChange={setRange}
      />
    </div>
  );
}

function RetentionNotice({ feature }: { feature?: string }) {
  const earliest = useRetentionHorizon();
  const isClipped = useDateRangeIsClipped();
  if (!isClipped) {
    return null;
  }

  return (
    <div
      title={`Data available since ${formatTimestampShorter(earliest)}`}
      className="m-0 mr-5 text-xs"
    >
      {feature || "this"} data only available for last{" "}
      {formatAvailableInterval(earliest)}
    </div>
  );
}

const formatAvailableInterval = (earliest: Moment): string => {
  if (earliest.isSameOrAfter(moment().subtract(25, "hours"))) {
    const hours = Math.round(moment().diff(earliest, "hours", true));
    return hours + " " + pluralize("hour", hours);
  } else {
    const days = Math.round(moment().diff(earliest, "days", true));
    return days + " " + pluralize("day", days);
  }
};

export default DateRangeBar;
